import React from 'react';
import { HistoryGrid } from '@1823-partners/core';
import { fetchCounterparty } from '../api';

const FIELD_NAMES = {
  COUNTERPARTY: 'Counterparty',
  NOTES: 'Notes',
};

const COLUMNS = [
  {
    headerName: 'Counterparty',
    field: 'COUNTERPARTY',
    pinned: 'left',
    minWidth: 200,
    flex: 2,
  },
  {
    headerName: 'Notes',
    field: 'NOTES',
    minWidth: 200,
    flex: 2,
  },
];

const CounterpartyHistory = ({ counterpartyId }) => (
  <HistoryGrid
    fetchHistory={() => fetchCounterparty(counterpartyId)}
    fetchParams={[counterpartyId]}
    fieldNames={FIELD_NAMES}
    columns={COLUMNS}
  />
);

export default CounterpartyHistory;
